import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Customer Name", key: "first_name" },
  { label: "Phone", key: "phone" },
  { label: "Total Orders", key: "total_orders" },
  { label: "Total Spent(Rs.)", key: "total_spent", render: (row) => Number(row.total_spent || 0).toFixed(2) },
  { label: "Total Discount(Rs.)", key: "total_discount", render: (row) => Number(row.total_discount || 0).toFixed(2) },
];

const CustomerReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No customer report data found."
  />
);

export default CustomerReport;
